function _(n,t,o){t.exports=function(){var n=Number.isNaN;return"function"==typeof n&&(!n({})&&n(NaN)&&!n(34))}}
//# sourceMappingURL=is-implemented.min.js.map